import * as opt from "lib/opt"
import { Variant } from "lib/enum"
import * as enm from "lib/enum"
import { ContainmentStatusDTO } from "models"

export type ContainmentStatusColor =
	| "#ba68c8" //palette.secondary.main
	| "#7b1fa2"
	| "#2e7d32"
	| "#ed6c02"
	| "#0288d1"
	| "#d32f2f"

export const StatusIds = {
	Initializing: "50e7084e-d75c-4352-aa9d-c4cb9aeb22b0",
	Processing: "be2973e3-2982-4e21-b245-8e902dc969e2",
	Completed: "dde08e01-d425-4e53-9c12-ee490be89e78",
	PartiallyCompleted: "97af9df6-a812-422f-b892-6367a8b41b15",
} as const

export type StatusVariantName = keyof typeof StatusIds

interface iContainmentStatus {
	[StatusIds.Initializing]: ContainmentStatusDTO
	[StatusIds.Processing]: ContainmentStatusDTO
	[StatusIds.Completed]: ContainmentStatusDTO
	[StatusIds.PartiallyCompleted]: ContainmentStatusDTO
}

export class ContainmentStatus extends Variant<iContainmentStatus> {
	GetColor(): ContainmentStatusColor {
		return this.Match({
			[StatusIds.Initializing]: () => "#7b1fa2",
			[StatusIds.Processing]: () => "#ba68c8",
			[StatusIds.Completed]: () => "#2e7d32",
			[StatusIds.PartiallyCompleted]: () => "#0288d1",
			_: () => "#d32f2f", // Default color for unknown statuses
		})
	}
	get Id() {
		return this.Tag
	}

	get Name(): string {
		return this.Match({
			[StatusIds.PartiallyCompleted]: () => "Partially Completed",
			_: (d) => d.name.Title(),
		})
	}
}

export function Processing(d: ContainmentStatusDTO): ContainmentStatus {
	return ContainmentStatus.New(StatusIds.Processing, d)
}

export function Initializing(d: ContainmentStatusDTO): ContainmentStatus {
	return ContainmentStatus.New(StatusIds.Initializing, d)
}
export function Completed(d: ContainmentStatusDTO): ContainmentStatus {
	return ContainmentStatus.New(StatusIds.Completed, d)
}
export function PartiallyCompleted(d: ContainmentStatusDTO): ContainmentStatus {
	return ContainmentStatus.New(StatusIds.PartiallyCompleted, d)
}

export const StatusFactories: Record<
	keyof typeof StatusIds,
	(d: ContainmentStatusDTO) => ContainmentStatus
> = {
	Processing,
	Initializing,
	Completed,
	PartiallyCompleted,
}

export function GetStatusFactory(
	statusName: string
): Opt<(d: ContainmentStatusDTO) => ContainmentStatus> {
	return opt.FromNullable(StatusFactories[statusName])
}

export function GetStatusNameFromId(id: string): Opt<StatusVariantName> {
	// Try to map name to ID
	return StatusIds.Entries()
		.Find(([, _id]) => id.Equal(_id))
		.Map(([key]) => key)
}

export type ContainmentStatusEnum = enm.Enum<iContainmentStatus, ContainmentStatus>
